import { Component, OnInit, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { AppService } from "src/_services/app.service";
import { ColorSketchModule } from "ngx-color/sketch";
import { ColorModalComponent } from "./color-modal/color-modal.component";
import { Router } from "@angular/router";
import { SapRoles } from "src/_constants/roleType";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { colorSets, colorKeys } from "../../../_constants/color";
import { stringify } from "querystring";

export interface DialogData {
  bannerIndex: number;
  operatorId: string;
  dialogueFor: string;
  bannerURL: string;
}

@Component({
  selector: "app-color-configuration",
  templateUrl: "./color-configuration.component.html",
  styleUrls: ["./color-configuration.component.scss"],
})
export class ColorConfigurationComponent implements OnInit {
  primary: string = "";
  background: string = "";
  subHeaderColor: string = "";
  tableBG: string = "";
  textColor: string = "";
  tableHead: string = "";
  textColor2: string = "";
  gradient1: string = "";
  gradient2: string = "";
  defaultColor: string = "";
  activeColor: string = "";
  orgPrimary: string = "";
  orgBackground: string = "";
  orgSubHeaderColor: string = "";
  orgTableBG: string = "";
  orgTextColor: string = "";
  orgTableHead: string = "";
  orgActiveColor: string = "";
  orgDefaultColor: string = "";
  orgTextColor2: string = "";
  orgGradient1: string = "";
  orgGradient2: string = "";
  Banner1: string = "";
  Banner2: string = "";
  Banner3: string = "";
  Banner4: string = "";
  Banner5: string = "";
  Banner6: string = "";
  Banner7: string = "";
  Banner8: string = "";
  Banner9: string = "";
  Banner10: string = "";
  Banner11: string = "";
  Banner12: string = "";
  sportsFromConfig: string[];
  isDisabled = true;
  selectedFile1: File = null;
  selectedFile2: File = null;
  selectedFile3: File = null;
  selectedFile4: File = null;
  selectedFile5: File = null;
  selectedFile6: File = null;
  selectedFile7: File = null;
  selectedFile8: File = null;
  selectedFile9: File = null;
  selectedFile10: File = null;
  selectedFile11: File = null;
  selectedFile12: File = null;
  OperatorId = new FormControl([]);
  operatorData = [];
  primaryC: string = "primary";
  backgroundC: string = "background";
  subHeaderColorC: string = "subHeaderColor";
  tableBGC: string = "tableBG";
  textColorC: string = "textColor";
  tableHeadC: string = "tableHead";
  defaultColorC: string = "defaultColor";
  activeColorC: string = "activeColor"
  textColor2C: string = "textColor2";
  gradient1C: string = "gradient1";
  gradient2C: string = "gradient2"
  fd = new FormData();
  showAlert: any = false;
  showAlertFor: number;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  sapRoles = SapRoles;
  BanneresMap = new Map<string, String>();
  enabledSports: string[] = [];
  finalisedSports: string[];
  dropdownSettings: any = {};
  lobbySettings: any = {};
  colorKeys = colorKeys;
  colorSets = colorSets;
  provider: string = "";
  lobbyName = new FormControl([]);
  configName = new FormControl([]);
  isTheme = false;
  configId = 1;
  configList = [1];
  lobbyList = [
    { id: "Exchange", name: "exchange" },
    { id: "SportsBook", name: "sportBook" },
    { id: "Premium", name: "premium" },
    { id: "Virtual", name: "virtual" },
  ];


  DialogRef: MatDialogRef<ColorModalComponent>;

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "operator_id",
      textField: "operator_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.lobbySettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
    this.OperatorId.setValue([this.userRole.role === this.sapRoles.OperatorAdmin
      ? {operator_id: this.userRole.operatorId,operator_name: this.userRole.operatorId}
      : {operator_id: "all",operator_name: "all"}]);
    if (this.userRole.role === this.sapRoles.OperatorAdmin) {
      this.lobbyName.setValue([this.lobbyList[0]]);
      this.getColorConfig();
      this.provider = this.lobbyName.value[0].name;
    }
    this.getOperatorData();
  }

  onSelectedOperatorId = (OperatorId) => {
    this.OperatorId.setValue([OperatorId]);
    for (let i = 1; i <= 12; i++) {
      this['Banner' + i] = null;
    }
    if (this.OperatorId.value[0].operator_id !== "all") {
      this.configId = 1;
      this.configList = [1];
      this.configName.setValue([this.configList[0]]);
      this.lobbyName.setValue([this.lobbyList[0]]);
      this.getColorConfig();
      this.provider = this.lobbyName.value[0].name;
    }
  };
  
  onSelectedLobbyName = (lobby) => {
    if (this.OperatorId.value[0].operator_id !== "all") {
      this.configId = 1;
      this.configList = [1];
      this.configName.setValue([this.configList[0]]);
      this.getColorConfig();
      this.provider = lobby.name
    }
  };

  onSelectConfigId(event) {
    this.configId = event
    if (this.OperatorId.value[0].operator_id !== "all") {
      this.getColorConfig();
    }
  }

  addNewTheme() {
    if (this.OperatorId.value[0].operator_id !== "all") {
      if (this.isTheme) {
        const len = this.configList.length;
        this.configList = this.configList.concat(len + 1);
        this.configName.setValue([this.configList[len]]);
        this.configId = this.configList[len];
        this.isTheme = false;
      } else {
        alert("please submit latest theme colors!!!")
      }
    }
  }

  deleteBanner(index, delOrView) {
    if (this.BanneresMap[`banner${index}`]) {
      const dialogRef = this.dialog.open(DeleteConfDialog, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          bannerIndex: index,
          operatorId: this.OperatorId.value[0].operator_id,
          bannerURL:this.BanneresMap[`banner${index}`],
          dialogueFor: delOrView === 0 ? "view" : "delete",
        },
      });
    } else {
      this.showAlert = true;
      this.showAlertFor = index;

      setTimeout(() => {
        this.showAlert = false;
      }, 5000);
    }
  }
  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          let operatorList = res.operators.filter((operator) => {
            if (operator.operator_id === "" || operator.operator_id === "all") {
            } else {
              return operator;
            }
          });
          this.operatorData = operatorList.sort((a, b) => {
            let fa = a.operator_id.toLowerCase(),
              fb = b.operator_id.toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getColorConfig() {
    this.isTheme = false;
    try {
      this.appService
        .getOperatorColorConfigurations(this.OperatorId.value[0].operator_id, this.lobbyName.value[0].name, this.configId)
        .subscribe((res) => {
          this.primary = res.primaryColor ? res.primaryColor : this.primary;
          this.background = res.backgroud ? res.backgroud : this.background;
          this.subHeaderColor = res.subHeader
            ? res.subHeader
            : this.subHeaderColor;
          this.tableBG = res.tableBackground
            ? res.tableBackground
            : this.tableBG;
          this.tableHead = res.tableHead ? res.tableHead : this.tableHead;
          this.textColor = res.textColor ? res.textColor : this.textColor;
          this.defaultColor = res.defaultColor ? res.defaultColor : "";
          this.activeColor = res.activeColor ? res.activeColor : "";
          this.textColor2 = res.textColor2 ? res.textColor2 : "";
          this.gradient1 = res.gradient1 ? res.gradient1 : "";
          this.gradient2 = res.gradient2 ? res.gradient2 : "";
          this.sportsFromConfig = res.sportsConfig
            ? res.sportsConfig
            : this.sportsFromConfig;
            this.orgPrimary = this.primary;
            this.orgBackground = this.background;
            this.orgSubHeaderColor = this.subHeaderColor;
            this.orgTableBG = this.tableBG;
            this.orgTextColor = this.textColor;
            this.orgTableHead = this.tableHead;
            this.orgDefaultColor = this.defaultColor;
            this.orgActiveColor = this.activeColor;
            this.orgTextColor2 = this.textColor2;
            this.orgGradient1 = this.gradient1;
            this.orgGradient2 = this.gradient2;
            if (res.configThemes > 0 ) {
              this.configList = [];
              this.isTheme = true
              for(let i=1; i<=res.configThemes; i++) {
                this.configList = this.configList.concat(i);
              }
            }
          if (res.banners && res.banners.length > 0) {
            for (let banner of res.banners) {
              const matches = banner.match(/(\d+)$/);
              const bannerNumber = matches ? matches[0] : null;
              if (bannerNumber) {
              this['Banner' + bannerNumber] = banner;
              this.BanneresMap['banner' + bannerNumber] = banner;
              }
            }
          }
          this.getEnabledSports();
          this.enablesubmit();
          // console.log("Banners - Map", this.BanneresMap);
        });
    } catch (err) {}
  }

  getProvider() {
    try {
      this.appService
        .opCategory(this.OperatorId.value[0].operator_id,)
        .subscribe((res) => {
          this.provider = res.categories[0]
        });
    } catch (err) {}
  }

  getEnabledSports() {
    try {
      this.appService
        .getEnabledSportsForOperator(this.OperatorId.value[0].operator_id)
        .subscribe((res) => {
          this.enabledSports = res.sports;
          this.finalisedSports = this.customSort(
            this.enabledSports,
            this.sportsFromConfig
          );
        });
    } catch (err) {}
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.finalisedSports,
      event.previousIndex,
      event.currentIndex
    );
  }

  customSort(enabledgames: string[], orderedgames: string[]): string[] {
    if (orderedgames == undefined || orderedgames == null) {
      return enabledgames;
    }

    const output: string[] = [];
    for (const item of enabledgames) {
      if (!orderedgames.includes(item)) {
        output.push(item);
      }
    }
    const joinedList = orderedgames.concat(output);

    return joinedList;
  }

  handlePrimaryColorChange(e) {
    this.primary = e.color.hex;
    this.enablesubmit();
  }

  handleBackgroundColorChange(e) {
    this.background = e.color.hex;
    this.enablesubmit();
  }

  handleSubHeaderColorChange(e) {
    this.subHeaderColor = e.color.hex;
    this.enablesubmit();
  }

  handlerTableBgChange(e) {
    this.tableBG = e.color.hex;
    this.enablesubmit();
  }

  handlerTableHeadChange(e) {
    this.tableHead = e.color.hex;
    this.enablesubmit();
  }

  handlerTextchange(e) {
    this.textColor = e.color.hex;
    this.enablesubmit();
  }

  resetColors() {
    this.primary = this.orgPrimary;
    this.background = this.orgBackground;
    this.subHeaderColor = this.orgSubHeaderColor;
    this.tableBG = this.orgTableBG;
    this.tableHead = this.orgTableHead;
    this.textColor = this.orgTextColor;
    this.defaultColor = this.orgDefaultColor;
    this.activeColor = this.orgActiveColor;
    this.textColor2 = this.orgTextColor2;
    this.gradient1 = this.orgGradient1;
    this.gradient2 = this.orgGradient2;
  }

  enablesubmit() {
    if (
      this.primary.length >= 6 &&
      this.background.length >= 6 &&
      this.subHeaderColor.length >= 6 &&
      this.tableBG.length >= 6 &&
      this.tableHead.length >= 6 &&
      this.textColor.length >= 6 &&
      this.defaultColor.length >=6 &&
      this.activeColor.length >=6
    ) {
      this.isDisabled = false;
    }
  }

  clearValues() {
    this.fd = new FormData();
    this.primary = "";
    this.background = "";
    this.subHeaderColor = "";
    this.tableBG = "";
    this.tableHead = "";
    this.textColor = "";
    this.defaultColor = "";
    this.activeColor = "";
    this.textColor2 = "";
    this.gradient1 = "";
    this.gradient2 = "";
    for (let i = 1; i <= 12; i++) {
      this['selectedFile' + i] = null;
    }
    if (this.userRole.role === this.sapRoles.SAPAdmin) {
      this.OperatorId.setValue([{operator_id: "all", operator_name:"all"}]);
    }
  }

  setColorConfig() {
    this.fd.append("primary", this.primary);
    this.fd.append("background", this.background);
    this.fd.append("subHeaderColor", this.subHeaderColor);
    this.fd.append("tableBG", this.tableBG);
    this.fd.append("tableHead", this.tableHead);
    this.fd.append("textColor", this.textColor);
    this.fd.append("defaultColor", this.defaultColor);
    this.fd.append("activeColor", this.activeColor);
    this.fd.append("textColor2", this.textColor2);
    this.fd.append("gradient1", this.gradient1);
    this.fd.append("gradient2", this.gradient2);
    this.fd.append("operatorId", this.OperatorId.value[0].operator_id);
    this.fd.append("sportsConfig", JSON.stringify(this.finalisedSports));
    this.fd.append("lobby_name", this.lobbyName.value[0].name);
    this.fd.append("config_id", String(this.configId));
    // console.log("fd",this.fd)
    this.appService.samepleApi(this.fd).subscribe(
      (res) => {
        this.clearValues();
        window.location.reload(); 
      },
      (err) => {
        this.clearValues();
      }
    );
  }

  handleFileInput(event: any, i): void {
    const file: File = event.target.files[0];
    const img = new Image();

    img.onload = () => {
      const height = img.height;
      const width = img.width;
      // console.log('Height:', height);
      // console.log('Width:', width);
      if (height < 430 || width < 1920) {
        this.appService.openErrorBar("size insufficient");
        this['selectedFile' + i] = null;
        this.fd.delete("banner" + i);
      } else {
        this.fd.append(
          "banner" + i,
            this['selectedFile' + i],
            this['selectedFile' + i].name
        )
      }
    };

    const reader = new FileReader();
    reader.onload = (e: any) => {
      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }

  onFileSelected(event, i) {
    this['selectedFile' + i] = <File>event.target.files[0];
    this.handleFileInput(event, i);
  }

  applyColorSet(colorSet: any) {
    this.primary = colorSet.primary;
    this.background = colorSet.background;
    this.subHeaderColor = colorSet.subHeaderColor;
    this.tableBG = colorSet.tableBG;
    this.textColor = colorSet.textColor;
    this.tableHead = colorSet.tableHead;
    this.textColor2 = colorSet.textColor2;
    this.gradient1 = colorSet.gradient1;
    this.gradient2 = colorSet.gradient2;
}

  openColorSelector(color:string, source: string) {
    this.DialogRef = this.dialog.open(ColorModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: { 
        type: source,
        color: color },
    });

    this.DialogRef.afterClosed().subscribe((res) => {
      switch (res.split(" ")[1]) {
        case this.primaryC:
          this.primary = res.split(" ")[0];
          break;
        case this.backgroundC:
          this.background = res.split(" ")[0];
          break;
        case this.subHeaderColorC:
          this.subHeaderColor = res.split(" ")[0];
          break;
        case this.tableBGC:
          this.tableBG = res.split(" ")[0];
          break;
        case this.primaryC:
          this.primary = res.split(" ")[0];
          break;
        case this.textColorC:
          this.textColor = res.split(" ")[0];
          break;
        case this.tableHeadC:
          this.tableHead = res.split(" ")[0];
          break;
        case this.defaultColorC:
          this.defaultColor = res.split(" ")[0];
          break;
        case this.activeColorC:
          this.activeColor = res.split(" ")[0];
          break;
        case this.textColor2C:
          this.textColor2 = res.split(" ")[0];
          break;
        case this.gradient1C:
          this.gradient1 = res.split(" ")[0];
          break;
        case this.gradient2C:
          this.gradient2 = res.split(" ")[0];
          break;
      }
      this.enablesubmit();

      // this.primary = res.split(' ')[0];
    });
  }
}

@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: "./delete-conf-modal.html",
  styleUrls: ["./delete-conf-modal.scss"],
})
export class DeleteConfDialog {
  constructor(
    public dialogRef: MatDialogRef<DeleteConfDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {}

  ngOnInit() {
    // console.log(this.data);
  }

  voidTheMarket() {}

  deleteTheBanner() {
        this.appService
      .deleteBanner(this.data.bannerIndex, this.data.bannerURL, this.data.operatorId)
      .subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close();
          // console.log("Banner Deleted");
          window.location.reload();
        }
      });
  }

  cancelDeletion() {
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
